import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import CustomDataTableEditable from "../../../../partials/content/CustomDataTableEditable";
import { getLeadMasterDataAPI } from "../../../../services/crm/leadService";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { Badge } from "react-bootstrap";
import Illustration from "../../../../partials/content/Illustration";
import {
  checkRegexEmail,
  checkRegexPhoneNumber,
  checkRegexWebsite,
} from "../../../../utils/utils";
function ConfirmUploadedLeads() {
  const { values, handleSubmit } = useFormikContext();
  const [auth, setAuth] = useState({});
  const [countryOptions, setCountryOptions] = useState([]);
  const [industryTypeOptions, setIndustryTypeOptions] = useState([]);
  const [businessSizeOptions, setBusinessSizeOptions] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [customerGroupOptions, setCustomerGroupOptions] = useState([]);

  useEffect(() => {
    function getLeadMasterData() {
      getLeadMasterDataAPI().then((response) => {
        const { data, auth } = response.data;
        const {
          businessSize,
          industryType,
          source,
          priority,
          countries,
          customerGroup,
        } = data;
        setMasterData(
          industryType,
          businessSize,
          source,
          priority,
          countries,
          customerGroup
        );
        setAuth(auth);
      });
    }
    getLeadMasterData();
  }, []);
  return (
    <>
      {values.length > 0 ? (
        <CustomDataTableEditable
          data={values}
          buttons={[
            {
              name: "Upload",
              onClick: (e) => {
                handleSubmit(e);
              },
              icon: "fas fa-upload",
              color: "success",
            },
          ]}
          onRowEditComplete={(e) => {
            let { newData, index } = e;
            values[index] = newData;

            /*Update selected dropdown label*/
            const customerGroupName = customerGroupOptions.filter(function(
              dropdown
            ) {
              return dropdown.value === values[index].customerGroupID;
            });
            if (customerGroupName.length > 0) {
              values[index].customerGroupName = customerGroupName[0].label;
            } else {
              values[index].customerGroupID = 0;
              values[index].customerGroupName = "";
            }

            const industryTypeName = industryTypeOptions.filter(function(
              dropdown
            ) {
              return dropdown.value === values[index].industryTypeID;
            });
            if (industryTypeName.length > 0) {
              values[index].industryTypeName = industryTypeName[0].label;
            } else {
              values[index].industryTypeID = 0;
              values[index].industryTypeName = "";
            }

            const businessSizeName = businessSizeOptions.filter(function(
              dropdown
            ) {
              return dropdown.value === values[index].businessSizeID;
            });
            if (businessSizeName.length > 0) {
              values[index].businessSizeName = businessSizeName[0].label;
            } else {
              values[index].businessSizeID = 0;
              values[index].businessSizeName = "";
            }

            const sourceName = sourceOptions.filter(function(dropdown) {
              return dropdown.value === values[index].sourceID;
            });
            if (sourceName.length > 0) {
              values[index].sourceName = sourceName[0].label;
            } else {
              values[index].sourceID = 0;
              values[index].sourceName = "";
            }

            const priorityName = priorityOptions.filter(function(dropdown) {
              return dropdown.value === values[index].priorityID;
            });
            if (priorityName.length > 0) {
              values[index].priorityName = priorityName[0].label;
            } else {
              values[index].priorityID = 0;
              values[index].priorityName = "";
            }

            const countryName = countryOptions.filter(function(dropdown) {
              return dropdown.value === values[index].countryCode;
            });
            if (countryName.length > 0) {
              values[index].countryName = countryName[0].label;
            } else {
              values[index].countryCode = "";
              values[index].countryName = "";
            }

            /*Update mass upload status ID*/
            values[index].statusID = 1;

            if (values[index].customerName === "") {
              values[index].statusID = 0;
            }
            if (
              values[index].customerGroupID === 0 &&
              values[index].customerGroupName !== ""
            ) {
              values[index].statusID = 0;
            }
            if (values[index].contactName === "") {
              values[index].statusID = 0;
            }
            if (values[index].position === "") {
              values[index].statusID = 0;
            }
            if (values[index].website !== "") {
              if (checkRegexWebsite(values[index].website) !== true) {
                values[index].statusID = 0;
              }
            }
            if (values[index].contactPhone === "") {
              values[index].statusID = 0;
            } else {
              if (checkRegexPhoneNumber(values[index].contactPhone) !== true) {
                values[index].statusID = 0;
              }
            }
            if (values[index].contactEmail === "") {
              values[index].statusID = 0;
            } else {
              if (checkRegexEmail(values[index].contactEmail) !== true) {
                values[index].statusID = 0;
              }
            }
            if (
              values[index].industryTypeID === 0 &&
              values[index].industryTypeName !== ""
            ) {
              values[index].statusID = 0;
            }
            if (
              values[index].businessSizeID === 0 &&
              values[index].businessSizeName !== ""
            ) {
              values[index].statusID = 0;
            }
            if (
              values[index].sourceID === 0 &&
              values[index].sourceName !== ""
            ) {
              values[index].statusID = 0;
            }
            if (
              values[index].priorityID === 0 &&
              values[index].priorityName !== ""
            ) {
              values[index].statusID = 0;
            }
            if (values[index].address === "") {
              values[index].statusID = 0;
            }
            if (values[index].city === "") {
              values[index].statusID = 0;
            }
            if (values[index].countryCode === "") {
              values[index].statusID = 0;
            }
          }}
          columns={[
            {
              header: "Mass Upload Status",
              field: "statusID",
              body: (rowData) => {
                if (rowData.statusID === 0) {
                  return <Badge variant="danger">Not Ready To Upload</Badge>;
                } else if (rowData.statusID === 1) {
                  return <Badge variant="success">Ready To Upload</Badge>;
                } else if (rowData.statusID === 2) {
                  return <Badge variant="primary">Successfully Uploaded</Badge>;
                } else if (rowData.statusID === 3) {
                  return (
                    <React.Fragment>
                      <span className="mr-3">
                        <BootstrapTooltip title={rowData.message}>
                          <span className="mr-1">
                            <i className="fas fa-exclamation-triangle kt-font-warning"></i>
                          </span>
                        </BootstrapTooltip>
                        <Badge variant="danger">Unsuccessfully Uploaded</Badge>
                      </span>
                    </React.Fragment>
                  );
                }
              },
              sortable: true,
              filter: true,
            },
            {
              header: "Lead Name",
              field: "leadName",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.leadName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Lead Name is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.leadName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.leadName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.leadName}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Customer Group",
              field: "customerGroupID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.customerGroupID === 0 &&
                    rowData.customerGroupName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Customer Group is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.customerGroupName}
                          </span>
                        </span>
                      </React.Fragment>
                    ) : rowData.customerGroupID === 0 &&
                      rowData.customerGroupName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Customer Group is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.customerGroupName}
                          </span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.customerGroupName}
                          </span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: customerGroupOptions,
            },
            {
              header: "Contact Name",
              field: "contactName",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.contactName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Contact Name is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.contactName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.contactName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.contactName}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Position",
              field: "position",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.position === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Position is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.position}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.position !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.position}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Website",
              field: "website",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.website === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.website}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.website !== "" ? (
                      <React.Fragment>
                        {checkRegexWebsite(rowData.website) === true ? (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="The data is acceptable">
                                <span className="mr-1">
                                  <i className="fas fa-check-circle kt-font-success"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">{rowData.website}</span>
                            </span>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="Website url must be valid. e.g. https://invifo.com or www.invifo.com">
                                <span className="mr-1">
                                  <i className="fas fa-times-circle kt-font-danger"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">{rowData.website}</span>
                            </span>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Taxpayer Identification Number",
              field: "taxpayerID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    <span className="mr-3">
                      <BootstrapTooltip title="The data is acceptable">
                        <span className="mr-1">
                          <i className="fas fa-check-circle kt-font-success"></i>
                        </span>
                      </BootstrapTooltip>
                      <span className="mr-1">{rowData.taxpayerID}</span>
                    </span>
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Phone Number",
              field: "contactPhone",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.contactPhone === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Phone Number is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.contactPhone}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.contactPhone !== "" ? (
                      <React.Fragment>
                        {checkRegexPhoneNumber(rowData.contactPhone) ===
                        true ? (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="The data is acceptable">
                                <span className="mr-1">
                                  <i className="fas fa-check-circle kt-font-success"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">
                                {rowData.contactPhone}
                              </span>
                            </span>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX">
                                <span className="mr-1">
                                  <i className="fas fa-times-circle kt-font-danger"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">
                                {rowData.contactPhone}
                              </span>
                            </span>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Email",
              field: "contactEmail",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.contactEmail === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Email is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.contactEmail}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.contactEmail !== "" ? (
                      <React.Fragment>
                        {checkRegexEmail(rowData.contactEmail) === true ? (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="The data is acceptable">
                                <span className="mr-1">
                                  <i className="fas fa-check-circle kt-font-success"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">
                                {rowData.contactEmail}
                              </span>
                            </span>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="Email must be valid. e.g. joe@invifo.com">
                                <span className="mr-1">
                                  <i className="fas fa-times-circle kt-font-danger"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">
                                {rowData.contactEmail}
                              </span>
                            </span>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Industry Type",
              field: "industryTypeID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.industryTypeID === 0 &&
                    rowData.industryTypeName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Industry Type is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.industryTypeName}
                          </span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.industryTypeName}
                          </span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: industryTypeOptions,
            },
            {
              header: "Business Size",
              field: "businessSizeID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.businessSizeID === 0 &&
                    rowData.businessSizeName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Business Size is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.businessSizeName}
                          </span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">
                            {rowData.businessSizeName}
                          </span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: businessSizeOptions,
            },
            {
              header: "Source",
              field: "sourceID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.sourceID === 0 && rowData.sourceName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Source is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.sourceName}</span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.sourceName}</span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: sourceOptions,
            },
            {
              header: "Priority",
              field: "priorityID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.priorityID === 0 && rowData.priorityName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Priority is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.priorityName}</span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.priorityName}</span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: priorityOptions,
            },
            {
              header: "Address",
              field: "address",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.address === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Address is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.address}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.address !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.address}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "City",
              field: "city",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.city === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="City is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.city}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.city !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.city}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Province / State",
              field: "province",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    <span className="mr-3">
                      <BootstrapTooltip title="The data is acceptable">
                        <span className="mr-1">
                          <i className="fas fa-check-circle kt-font-success"></i>
                        </span>
                      </BootstrapTooltip>
                      <span className="mr-1">{rowData.province}</span>
                    </span>
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Country",
              field: "countryCode",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.countryCode === "" &&
                    rowData.countryName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Country is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.countryName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.countryCode === "" &&
                      rowData.countryName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Country is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.countryName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.countryCode !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.countryName}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: countryOptions,
            },
            {
              header: "Postal Code",
              field: "postalCode",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    <span className="mr-3">
                      <BootstrapTooltip title="The data is acceptable">
                        <span className="mr-1">
                          <i className="fas fa-check-circle kt-font-success"></i>
                        </span>
                      </BootstrapTooltip>
                      <span className="mr-1">{rowData.postalCode}</span>
                    </span>
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
          ]}
        />
      ) : (
        <Illustration
          imageSource="INVIFO Setup.png"
          description="Good Start! You're ready for Mass Upload!"
          guidance="Hint: upload master data based on template provided"
          descriptionLeftIcon="fas fa-info-circle kt-font-success"
        ></Illustration>
      )}
    </>
  );
  function setMasterData(
    industryTypes = [],
    businessSizes = [],
    sources = [],
    priorities = [],
    countries = [],
    customerGroup = []
  ) {
    let industryTypeOptionsTmp = [];
    let businessSizeOptionsTmp = [];
    let sourceOptionsTmp = [];
    let priorityOptionsTmp = [];
    let countryOptionsTmp = [];
    let customerGroupOptionsTmp = [];
    if (typeof industryTypes !== "undefined") {
      industryTypes.forEach((industryType) => {
        industryTypeOptionsTmp.push({
          value: industryType.ID,
          label: industryType.industryTypeName,
        });
      });
    }

    if (typeof businessSizes !== "undefined") {
      businessSizes.forEach((businessSize) => {
        businessSizeOptionsTmp.push({
          value: businessSize.ID,
          label: businessSize.businessSizeName,
        });
      });
    }

    if (typeof sources !== "undefined") {
      sources.forEach((source) => {
        sourceOptionsTmp.push({
          value: source.ID,
          label: source.sourceName,
        });
      });
    }

    if (typeof priorities !== "undefined") {
      priorities.forEach((priority) => {
        priorityOptionsTmp.push({
          value: priority.ID,
          label: priority.priorityName,
        });
      });
    }

    if (typeof countries !== "undefined") {
      countries.forEach((country) => {
        countryOptionsTmp.push({
          value: country.countryCode,
          label: country.countryName,
        });
      });
    }
    if (typeof customerGroup !== "undefined") {
      customerGroup.forEach((group) => {
        customerGroupOptionsTmp.push({
          value: group.ID,
          label: group.groupName,
        });
      });
    }
    setIndustryTypeOptions(industryTypeOptionsTmp);
    setBusinessSizeOptions(businessSizeOptionsTmp);
    setSourceOptions(sourceOptionsTmp);
    setPriorityOptions(priorityOptionsTmp);
    setCountryOptions(countryOptionsTmp);
    setCustomerGroupOptions(customerGroupOptionsTmp);
  }
}

export default ConfirmUploadedLeads;
